<div class="treasure-hunt-add-actions">
  <ion-row >
    <ion-col class="addAction-title">
      <ion-label class="addAction-label">
        {{ 'Add action' | translate }}  
      </ion-label>
    </ion-col>
  </ion-row>

  <div>
    <form [formGroup]="form" (ngSubmit)="submit()">

      <mat-form-field appearance="outline" class="th-custom-input">
        <mat-label>{{ 'ACTION.FORM_DUEDATE' | translate }}</mat-label>

        <input
          matInput
          [matDatepicker]="picker"
          formControlName="dueDateTime"
          [min]="minDate"
          [readonly]="true"
          placeholder="{{ 'ACTION.FORM_DUEDATE_PLACEHOLDER' | translate }}"
          (focus)="picker.open()"
          (click)="picker.open()"
        />

        <mat-datepicker-toggle matSuffix [for]="picker">
          <ion-icon matDatepickerToggleIcon src="assets/img/treasure_hunt/finding/calendar.svg"></ion-icon>
        </mat-datepicker-toggle>
        <mat-datepicker #picker panelClass="th-datepicker-panel"></mat-datepicker>

        <!-- <mat-error *ngIf="form.get('dueDateTime')?.hasError('required')">
          {{ 'APP_FIELD_REQUIRED' | translate }}
        </mat-error> -->
      </mat-form-field>

      <mat-form-field *ngIf="false" appearance="outline" class="th-custom-input">
        <mat-label>{{ 'ACTION.FORM_ASSIGNED_TO' | translate }}</mat-label>
        <input  matInput formControlName="assignedTo" placeholder="assign to" />
        <!-- <mat-error *ngIf="form.get('actionTitle')?.hasError('required')">
          {{ 'APP_FIELD_REQUIRED' | translate }}
        </mat-error> -->
      </mat-form-field>

      <span class="assign-to-container">
          <div class="assign-label">Assign to</div>
          <ion-item lines="none" class="assign-container" (click)="openUsersModal()">
            <div class="assign-field">
             <ng-container *ngIf="areaOwnerData?.email && !selectedUserData?.email;">
                <ion-chip class="assignee-chip" outline="false">
                  <ion-label class="assignee-name">{{ areaOwnerData?.assign_to }}</ion-label>
                  <span class="recommended-pill">Recommended</span>
                  <button
                    type="button"
                    class="close-btn"
                    aria-label="Remove assignee"
                  >
                    ×
                  </button>
                </ion-chip>
              </ng-container>
              <ng-container *ngIf="selectedUserData?.email">
                <ion-chip class="assignee-chip" outline="false">
                  <ion-label class="assignee-name">{{ selectedUserData?.Fname + " " + selectedUserData?.Lname  }}</ion-label>
                  <button
                    type="button"
                    class="close-btn"
                    aria-label="Remove assignee"
                  >
                    ×
                  </button>
                </ion-chip>
              </ng-container>
              <!-- <ng-template #noAssignee>
                <span class="placeholder">Search and assign</span>
              </ng-template> -->
            </div>
            <button
              type="button"
              class="search-btn"
              aria-label="Open assignee search"
            >
              <ion-icon (click)="openUsersModal()" name="search-outline"></ion-icon>
            </button>
          </ion-item>
      </span>

    <div class="priority">
      {{'ACTION.FORM_PRIORITY' | translate}} <span class="priority_mandatory">*</span>
    </div>
    <div class="wrapper add_action_div">
      <div class="action_sub_blk" *ngFor="let option of priority; let i = index" (change)="onChange(option.value)">
        <input
          type="radio"
          name="priority"
          id="{{option.value}}"
          class="radio_blk"
          formControlName="priority"
          [value]="option.value"
          [ngClass]="{'checked': option.value == form.get('priority')?.value }"
          [disabled]="option.disabled"
        />
        <label for="{{option.value}}" class="option" [ngClass]="{'checked': option.value == form.get('priority')?.value,'action_unchecked': option.value != form.get('priority')?.value }" >
        <span [ngClass]="{'checked': option.value == form.get('priority')?.value,'action_unchecked': option.value != form.get('priority')?.value}">{{option.label | translate}}</span>
        </label>
      </div>
    </div>
    <!-- <mat-error *ngIf="form.get('priority')?.hasError('required')">
      {{ 'VPC.FORM_DESC' | translate }}
    </mat-error> -->

      <mat-form-field appearance="outline" class="th-custom-input">
        <mat-label>{{ 'VPC.FORM_DESC' | translate }}</mat-label>
        <textarea matInput formControlName="actionSummary" rows="3" maxlength="255" placeholder="Description"></textarea>
        <!-- <mat-error *ngIf="form.get('actionDescription')?.hasError('required')">
          {{ 'APP_FIELD_REQUIRED' | translate }}
        </mat-error> -->
      </mat-form-field>

      <!-- <button mat-raised-button color="primary" [disabled]="form.invalid">
        {{ 'ADD_QR.BTN_SAVE' | translate }}
      </button> -->

    <div class="btn-options">
      <ion-button size="large" type="submit" [disabled]="form.invalid" class="text-transform-none btn-filled">
        Add now
      </ion-button>

      <ion-label (click)="closeModal()">
        cancel
      </ion-label>
    </div>

    </form>
  </div>
</div>
